/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';

const useUpdateExam = () => {
  const withoutSubjectModalities = ['Sur table', 'Oral - cours en présentiel', 'Voie postale', 'Oral', 'Oral Participation', 'Oral : Role Play', 'Oral : Poster Presentation', 'Oral : Case study'];

  const updateExam = (examId, newData, semestersList) => {
    if (newData.examBegin >= newData.examEnd) {
      toastError('La date et l\'heure de début de l\'examen doivent être avant la date et l\'heure de fin.');
      return;
    }
    semestersList.forEach((sem) => {
      if (newData.semester === sem.value) {
        newData.semester = sem;
      }
    });
    const newDataObj = {
      catchUp: newData.catchUp,
      modality: newData.modality.value,
      EWCorrect: newData.modality.value !== 'Quiz automatisé' ? newData.EWCorrect : false,
      deliveryDate: newData.deliveryDate ? newData.deliveryDate : new Date(),
      examSubject: withoutSubjectModalities.includes(newData.examSubject.name) ? null : newData.examSubject,
      examBegin: newData.examBegin,
      examEnd: newData.examEnd,
    };
    if (newData.duration) {
      newDataObj.duration = parseInt(newData.duration, 10);
    }
    if (newData.modality.value === 'Oral Participation'
      || newData.modality.value === 'Oral - cours en présentiel'
      || newData.modality.value === 'Oral : Role Play'
      || newData.modality.value === 'Oral : Case study'
      || newData.examSubject.name === 'Deposit files') {
      newDataObj.duration = moment(new Date(newData.examEnd)).diff(moment(new Date(newData.examBegin)), 'minutes');
    }
    elearningDetailsServices.updateElearningOption(examId, newDataObj)
      .then((res) => {
        toastSuccess('Examen modifié avec succès');
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour de l\'examen.');
      });
  };
  return { updateExam };
};

export default useUpdateExam;
